export default __webpack_public_path__ + "static/media/13_LeftToRightSquares_Bottom.3d6c4831.mp4";